import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import {
    Select,
    SelectItem,
    SelectTrigger,
    SelectValue,
    SelectContent
} from '../../Common/ui/select'
import { cn } from 'src/lib/utils'
import { useCompStore } from './Store/ComplianceStore'
import { compFreqOptions } from 'src/Entities/Governance'
import { getYear } from 'date-fns'
import { IoMdInformationCircleOutline } from 'react-icons/io'
function TimelineDialog ({ isOpen, cycle, handleClose, frequency, period, timeline = 0, interCutOff = 0 }) {
    const listMonths = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar' ]

    const { getCompFrequency, compFrequency } = useCompStore()
    const [ frequencies, setFrequencies ] = useState()
    useEffect(() => {
        if (isOpen) {
            const getCurrentDate = new Date()
            let getYear = getCurrentDate.getFullYear()
            const yearOptions = []
            while (+getYear < 2050) {
                getYear = getYear + 1
                yearOptions.push({ value: `${getYear - 1}-${getYear}`, label: `${getYear - 1}-${getYear}` })
                // yearOptions.push({ value: `${getYear}`, label: `${getYear}` })
            }
            setOptions(yearOptions)
            getCompFrequency()
        }
    }, [isOpen])
    useEffect(() => {
        if (compFrequency?.length > 0) {
            setFrequencies(compFrequency)
        }
    }, [compFrequency])
    const [ options, setOptions ] = useState([])

    useEffect(() => {
        handleYearOption(selectedValues.option)
    }, [ options, isOpen ])
    const [ timeLineData, setTimeLineData ] = useState([])
    const [ selectedValues, setSelectedValues ] = useState({
        option: `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`
        // option: `${new Date().getFullYear()}`
    })

    const freqCal = (freq) => {
        switch (frequency) {
        case compFreqOptions[0].id:
            return 1
        case compFreqOptions[1].id:
            return 3
        case compFreqOptions[2].id:
            return 6
        case compFreqOptions[3].id:
            return 12
        default:
            break
        }
    }

    const handleYearOption = (value) => {
        const gap = freqCal(frequency)
        const date = new Date()
        date.setDate(1)
        date.setMonth(cycle - 1)
        date.setHours(0, 0, 0, 0)
        date.setFullYear(value.split('-')[0])
        let dateLimit = new Date()
        dateLimit.setMonth(cycle + 11)
        dateLimit.setDate(1)
        dateLimit.setDate(dateLimit.getDate() - 1)
        dateLimit.setHours(0, 0, 0, 0)
        const data = []
        setTimeLineData([])
        while (date < dateLimit) {
            dateLimit = new Date(dateLimit)
            const obj = {}
            const val = date.getMonth() + gap
            let last = false
            if (val === 12) {
                last = true
            } else {
                last = false
            }
            date.setMonth(date.getMonth() + gap)
            obj.expMonth = `${listMonths[Math.abs(last ? 11 : date.getMonth() - 1)]}-${date.getFullYear()}`
            const disData = new Date(date.getTime() + 5.5 * 60 * 60 * 1000)
            disData.setHours(disData.getHours() - 24)
            disData.setDate(disData.getDate() + (period === 2 ? -(+timeline) : +timeline))
            obj.dueDate = `${listMonths[disData.getMonth()]}-${disData.getDate()}-${disData.getFullYear()}`
            data.push(obj)
            if (date > dateLimit) {
                break
            }
            date.setDate(1)
        }
        setTimeLineData(data)
        setSelectedValues({ ...selectedValues, option: value })
    }
    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { overflowX: 'hidden', zIndex: 1300 } }}
            >
                <DialogContent sx={{ padding: 0 }}>
                    <div className='h-12 bg-primary flex items-center p-[0.8rem]'>
                        <div style={{ color: '#fff' }} className='flex-grow text-center text-white font-semibold'>{frequencies?.find(ele => +ele.id === +frequency)?.name === 'Annually' ? 'Annual' : frequencies?.find(ele => +ele.id === +frequency)?.name}</div>
                        <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div className='cursor-pointer'><img src='/Common/Icon/CloseDialogX.svg' onClick={handleClose} /></div>
                        </Tooltip>
                    </div>
                    <div className='flex justify-between items-center p-4 !pb-0'>
                        <div className='flex gap-3'>
                            <div className='flex gap-2 items-center'>
                                <div className='h-4 w-4 rounded-full bg-[#3C4048]'></div>
                                <div className='font-semibold'>Due for</div>
                            </div>
                            <div className='flex gap-2 items-center'>
                                <div className='h-4 w-4 rounded-full bg-primary'></div>
                                <div className='font-semibold'>Due By</div>
                            </div>
                        </div>
                        <div className='flex items-center justify-center gap-2'>
                            <Tooltip
                                title={
                                    <div style={{ fontSize: '14px', color: 'black', padding: '8px' }}>
                                        <h2 className='border-b pb-2 text-lg text-primary'>Info</h2>
                                        <p className='pt-2 text-sm font-normal'>Compliance dates falling on non-working days will be adjusted to the nearest prior working day.</p>
                                    </div>
                                }
                                placement="bottom-end"
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: '#fff',
                                            border: '1px solid hsl(var(--primary-foreground))',
                                            color: 'black',
                                            boxShadow: '0px 0px 8px 4px hsl(var(--primary-foreground))',
                                            fontSize: '14px',
                                            maxWidth: '400px',
                                            padding: '8px',
                                            borderRadius: '4px'
                                        }
                                    },
                                    arrow: {
                                        sx: {
                                            color: 'hsl(var(--primary))'
                                        }
                                    }
                                }}
                            >
                                <div>
                                    <IoMdInformationCircleOutline className="lg:w-8 lg:h-8 xl:w-6 xl:h-6 text-primary cursor-pointer" />
                                </div>
                            </Tooltip>
                            <Select
                                key={name}
                                onValueChange={e => { handleYearOption(e) }}
                                value={selectedValues?.option}
                                defaultValue={selectedValues?.option}
                            >
                                <SelectTrigger className={cn('w-[150px] h !mt-0 rounded rounded-tl-none rounded-bl-none !border-none !ring-0 !shadow-none select-trigger')} >
                                    <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                    {options.map((item, index) => {
                                        return (
                                            <SelectItem value={item?.value} key={index}>{item?.label}</SelectItem>
                                        )
                                    })
                                    }
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                    <div className='w-full flex flex-col justify-center items-center py-5' >
                        <div className='flex flex-wrap border w-[90%] justify-center p-5 gap-2'>
                            { timeLineData.map((item, i) => {
                                return (
                                    <div key={i} className={cn(frequency === 3 || frequency === 2 ? 'w-[240px] h-[70px] justify-center' : 'w-[120px] justify-between', 'flex flex-row items-center')}>
                                        {frequency !== 1 && <div className={cn(frequency === 3 || frequency === 2 ? 'pr-4' : '')}>
                                            <div className='text-lg text-border font-bold'>{frequency === 4 ? getYear(item.dueDate) : frequency === 3 ? `${i + 1} Half` : `Q${i + 1}`}</div>
                                        </div>}
                                        <div>
                                            <div className='text-sm font-[#3C4048]'>{item.expMonth}</div>
                                            <div className='text-md text-primary font-bold'>{item.dueDate}</div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>
                    <div style={{ borderTop: '1px solid hsl(var(--primary-foreground))' }} className='flex gap-2 items-center p-4'>
                        <div className='text-primary text-semibold text-lg flex items-center gap-1'><span><img src='/Common/Icon/warningIcon.svg'/>  </span> Internal Cut Off :</div>
                        <div className='text-md flex items-center gap-3'>{interCutOff} Days before the deadline </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

TimelineDialog.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    frequency: PropTypes.number,
    period: PropTypes.number,
    timeline: PropTypes.number,
    interCutOff: PropTypes.number
}

export default TimelineDialog
